import { Moon } from "lucide-react";
import { Chapter, Reveal } from "./Shared";

export default function SpeedSection() {
  return (
    <section id="speed" data-testid="speed-section" className="relative">
      <div className="mx-auto max-w-4xl px-6 py-16 text-center sm:py-20">
        <Reveal>
          <Chapter num="06" label="Overnight Turnaround" className="justify-center" />
          <h2 className="mt-6 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
            Have an Idea Tonight? Sell It Tomorrow.
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-base leading-relaxed text-slate-400">
            Submit your brief before midnight. Wake up to production-ready artwork before 8AM EST.
          </p>
          <span className="mt-8 inline-flex items-center gap-2 rounded-full border border-amber-400/40 bg-amber-400/10 px-5 py-2.5 font-mono text-[11px] font-bold uppercase tracking-[0.2em] text-amber-300">
            <Moon className="h-3.5 w-3.5" />
            5PM to 8AM EST — every night
          </span>
        </Reveal>
      </div>
    </section>
  );
}